import React from 'react'
import {t} from '../helpers/translate.js'

let config = require('config');

class ProductCategories extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
    	<div className="container">
        <h2 className="page-title text-center">{t('Sell Now')}</h2>
    		<iframe 
    			className='product-iframe'
    			src={`${config.default.agent_portal}/login/en/travel-insurance/agent-categories/${sessionStorage.getItem('csr_token')}`} 
			/>
		</div>
    )
  }
}
ProductCategories.displayName = 'ProductCategories';
export default ProductCategories;



// WEBPACK FOOTER //
// ./src/components/ProductCategories.js